var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4 10.474 10.877 7.017v13.51L4 22.754v-12.28z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.93 30.825V17.49l12.807-6.49v12.983L15.93 30.825z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.772 14.86 2.807 1.754 2.806-1.404-2.807-1.754-2.808 1.404z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m9.79 13.105 2.105 1.228 2.982-1.228-2.28-1.228-2.808 1.228z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m6.982 11.35 2.106 1.404 2.631-1.228-2.281-1.403L6.98 11.35z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.596 6.105 11l2.807-1.404-1.93-1.228L4 9.596z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m16.28 13.105 2.983 1.755 2.632-1.404-2.807-1.579-2.807 1.228z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m19.965 11.526 2.456 1.58 2.633-1.229-2.807-1.579-2.281 1.228z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m23.123 10.123 2.807 1.403 2.456-1.228-2.807-1.403-2.457 1.228z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m13.474 11.526 2.105 1.228 2.806-1.228-2.456-1.228-2.456 1.228z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m10.491 9.772 1.931 1.403 2.808-1.052-2.28-1.228-2.457.877z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m12.246 8.544-2.457.877-1.93-1.227 2.456-.877 1.93 1.228z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.807 9.772 18.912 11l2.456-1.228-2.28-1.228-2.28 1.228z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m15.403 7.491 2.106 1.23 2.455-1.404-2.105-1.053-2.457 1.228z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m10.491 6.439 2.107 1.402 2.631-1.228-1.754-1.053-2.983.879z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m15.93 3.807 1.403 1.053 1.93-1.053c-.35-.292-1.123-.912-1.403-1.053-.28-.14-1.404.644-1.93 1.053z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m20.667 2.228 1.93 1.053 2.28-.876L22.947 1l-2.28 1.228z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m21.017 6.263 1.93 1.228 2.281-.876-1.93-1.228-2.28.877z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/CUBE.bcaada35cfdcea5230d502f6012c0a5a.svg";
export { ForwardRef as ReactComponent };